import React from 'react';
import { AppBar, Typography, Divider, Stack, useTheme, useMediaQuery, Skeleton } from '@mui/material';
import { useAuth } from '../../context/authContext/AuthContext';
import AvatarComponent from './avatar/AvatarComponent';
import './Header.scss';
import logo from '../../images/logo.png';
import packageJson from '../../../package.json';
import { useAppInsightConsumer } from '../../context/appInsightContext/AppInsightContext';

const Header: React.FC = () => {
  const { isLoading, userData } = useAuth();
  const username = userData?.profile.name;
  const designation = userData?.profile?.title as string;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { trackPageView } = useAppInsightConsumer();

  // AppInsight tarcking of page
  trackPageView('Header');
  
  return (
    <AppBar position="static" className='appBar'>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          height: '100%',
          padding: '0 20px',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            height: '100%',
          }}
          spacing={2}
        >
          <img src={logo} alt="Alaska Logo" height={35} />
          divider= {!isSmallScreen && <Divider orientation="vertical" flexItem />}
          <Typography
            variant="h6"
            className='title'
          >
            QX Marginal Weather Notes
          </Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            marginLeft: 'auto',
          }}
        >
          <Typography variant="body2" className='version'> v{packageJson.version} </Typography>
          {isLoading ? (
            <Stack direction="row" spacing={2} alignItems="center">
              <Skeleton
                data-testid="avatar-skeleton"
                variant="circular"
                width={35}
                height={35}
                sx={{ backgroundColor: '#13B2D2', border: '3px solid #157BB9' }}
              />
            </Stack>
          ) : (
            <AvatarComponent
              name={username ?? 'Unknown'}
              designation={designation ?? 'Unknown'}
              className="avatar"
            />
          )}
        </Stack>
      </Stack>
    </AppBar>
  );
};

export default Header;